import { motion } from "framer-motion";

const CEO_PHOTO = "https://customer-assets.emergentagent.com/job_8f485194-8130-4d3f-9b3d-35cc229fe041/artifacts/ygz9fmiz_24F12A75-EBF1-49C9-8823-839B493F3DED.PNG";

export const CEO = () => {
  return (
    <section id="ceo" className="relative py-14 lg:py-20 bg-[#0D0D0D] border-y border-[#D4AF37]/25 overflow-hidden">
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-[#D4AF37]/5 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="absolute -inset-4 bg-gradient-to-br from-[#D4AF37]/20 via-transparent to-[#FF2A2A]/10 rounded-3xl blur-xl" />
          <img
            src={CEO_PHOTO}
            alt="Paul Michaels, CEO of Robust Entertainment"
            data-testid="ceo-photo"
            className="relative w-full max-w-md mx-auto rounded-2xl border-2 border-[#D4AF37] shadow-[0_0_30px_rgba(212,175,55,0.25)] object-cover"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-center"
        >
          <p className="text-sm sm:text-base font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-4">Meet The CEO</p>
          <h2 className="font-heading heading-fluid font-medium tracking-normal text-metal mb-8">
            Paul Michaels
          </h2>
          <div className="space-y-5 text-lg text-zinc-300 leading-relaxed">
            <p>
              With over 30 years of experience in the entertainment and holiday park industry, Paul Michaels has dedicated
              his career to creating exceptional guest experiences and developing high-performing entertainment teams.
            </p>
            <p>
              Paul began his journey as a Redcoat, where he quickly discovered his passion for live entertainment, guest
              engagement and show production. Through creativity, hard work and leadership, he progressed through the
              industry to manage entertainment operations across more than 30 holiday venues throughout the United Kingdom.
            </p>
            <p>
              As CEO of Robust Entertainment, Paul combines decades of operational experience with a forward-thinking
              approach to entertainment, helping clients create memorable productions, build engaging character brands,
              train confident teams and deliver entertainment that guests remember long after their holiday ends.
            </p>
          </div>
          <a
            href="https://wa.me/447539528505"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ceo-cta"
            className="inline-block mt-8 border border-[#D4AF37] text-gold font-medium px-8 py-4 rounded-full hover:bg-[#D4AF37]/10 transition-colors duration-300"
          >
            Speak With Paul About Your Venue
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CEO;
